import { render, staticRenderFns } from "./PageAudioguide.vue?vue&type=template&id=750ba46a&"
import script from "./PageAudioguide.vue?vue&type=script&lang=js&"
export * from "./PageAudioguide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('750ba46a')) {
      api.createRecord('750ba46a', component.options)
    } else {
      api.reload('750ba46a', component.options)
    }
    module.hot.accept("./PageAudioguide.vue?vue&type=template&id=750ba46a&", function () {
      api.rerender('750ba46a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/audioguide/PageAudioguide.vue"
export default component.exports